import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

import chevron from '../../../../../assets/images/icons/arrow/chevron-right.svg';

export const useStyles = makeStyles(({ fontWeights, palette }: Theme) => ({
  root: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    border: `1px solid ${palette.grey[400]}`,
    borderRadius: '1rem',
    overflow: 'hidden',
  },

  rootGrey: {
    backgroundColor: palette.grey[200],
  },
  rootDisabled: {
    backgroundColor: palette.grey[200],
  },
  profileContent: {
    position: 'relative',
    display: 'flex',
    gap: '0.75rem',
    alignItems: 'center',
    padding: '0.75rem 4rem 0.75rem 1rem',
    fontWeight: fontWeights.medium,
  },
  img: {
    width: '2.75rem',
    height: 'auto',
  },
  text: {
    display: 'flex',
    flexDirection: 'column',
  },
  textLetter: {
    width: 'calc(100% - 3.5rem)',
    wordBreak: 'break-word',
  },
  link: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    border: 'none',
    padding: 0,
    background: `no-repeat url(${chevron})`,
    backgroundSize: '1rem',
    backgroundPositionY: 'center',
    backgroundPositionX: 'calc(100% - 2rem)',
    cursor: 'pointer',
  },
  linkDisabled: {
    backgroundImage: 'none',
    cursor: 'default',
    pointerEvents: 'none',
  },
  linkHidden: {
    display: 'none',
  },
  date: {
    fontWeight: fontWeights.regular,
    fontSize: '0.875rem',
    lineHeight: 1.4,
  },
  letter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '2.75rem',
    height: '2.75rem',
    borderRadius: '50%',
    color: palette.common.white,
    fontSize: '1.875rem',
    lineHeight: 1,
    fontWeight: fontWeights.medium,
  },

  banner: {
    padding: '0.875rem 1rem 0.875rem 0',
    borderTop: `1px solid ${palette.grey[400]}`,
    marginLeft: '4.5rem',
    marginRight: '1rem',
  },
  bannerContent: {
    display: 'flex',
    gap: '0.75rem',
    marginBottom: '0.75rem',
    alignItems: 'flex-start',
  },
  bannerIcon: {
    color: palette.grey[500],
    fontSize: '1.25rem',
    flexShrink: 0,
    marginTop: '0.125rem',
  },
  bannerText: {
    flex: 1,
    fontSize: '0.875rem',
    lineHeight: 1.5,
    color: palette.text.primary,
    '& strong': {
      fontWeight: fontWeights.regular,
    },
  },
  bannerLink: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    background: 'none',
    border: 'none',
    padding: 0,
    color: palette.primary.main,
    fontSize: '0.875rem',
    fontWeight: fontWeights.regular,
    cursor: 'pointer',
    textDecoration: 'none',
    fontFamily: 'inherit',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  helpIcon: {
    fontSize: '1rem',
    color: palette.info.main,
  },

  bannerIconGrey: {
    color: palette.grey[500],
  },

  letterDisabled: {
    color: palette.grey[600],
  },
}));
